/* eslint-disable no-unused-vars */
import AOS from 'chart.js';

export default {
  init() {
    // JavaScript to be fired on the dashboard help page
    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
      event.preventDefault();
      $(this).ekkoLightbox();
    });


    // Return with commas in between
    var numberWithCommas = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    var renderBookingLink = function(data) {
      var bookingCode = data || '';
      var escapedBookingCode = $('<div>').text(bookingCode).html();

      return '<a class="booking-code-pill-link" href="/dashboard/booking/'+ encodeURIComponent(bookingCode) +'">'+ escapedBookingCode +'</a>';
    };

    // First, get the search parameter: example.com#search=yourkeyword
    var urlParams = new URLSearchParams(location.search);
    var searchString = urlParams.get('search');

    var table = $('#booking-table').DataTable({
      'createdRow': function( row, data, index ) {

        $('td', row).eq(7).addClass('font-weight-bold'); // GROSS

        if ( data[12] == 'STOP' ) {
          // CANCELLED
          $(row).addClass('bg-light');
          $('td', row).addClass('text-secondary'); // GROSS
          $('td', row).eq(0).find('span').addClass('badge badge-danger'); // Booking ID

        } else {

          if ( data[13] == false ) {
            $(row).addClass('bg-danger bg-gradient-danger');
            $('td', row).addClass('text-white'); // GROSS
          }

          if ( data[12] == 'PAID' ) {
            // PAID
            $('td', row).eq(0).find('span').addClass('badge badge-success');
          }

          if ( data[12] == 'HOLD' ) {
            // RESERVED
            $('td', row).eq(0).find('span').addClass('badge badge-primary');
          }

          if ( data[12] == 'PEND' ) {
            // PENDING
            $('td', row).eq(0).find('span').addClass('badge badge-warning');
          }

          if ( data[12] == 'PART' ) {
            // DEPOSIT
            $('td', row).eq(0).find('span').addClass('badge badge-deposit');
          }

          var payout = 0;
          if ( data[8] != null ) {
            payout = parseFloat(data[8]);
          }

          var hfee = 0;
          if ( data[9] != null ) {
            hfee = parseFloat(data[9]);
          }

          var pfee = 0;
          if ( data[10] != null ) {
            pfee = parseFloat(data[10]);
          }

          var result = ( payout + hfee + pfee ).toFixed(2);
          var gross = parseFloat(data[7]).toFixed(2);

        /* eslint-disable no-console */
        // console.log( data[0] + '|' + data[12] );
        /* eslint-enable no-console */

          if ( result != gross ) {
            $('td', row).eq([8, 9, 10]).addClass('text-danger'); // PAID OUT, HOST FEE, PAYMENT PROCESSING FEE
          }
        }

        // FUTURE: check would be to compare the check-in date
      },
      pageLength : 25,
      processing: true,
      serverSide: true,
      searchDelay: 250,
      order: [[ 3, 'desc' ]],
      ajax: '/json/bookings',
      stateSave: true,
      'columnDefs': [{
        render: $.fn.dataTable.render.number( ',', '.', 2, '$' ),
          'targets': [7, 8, 9, 10, 11],
        },
        {
          'targets': [ 12 ],
          'visible': false, // hide the status column, allow it to be searchable
          'searchable': true,
        },
        {
          'targets': 0,
          'render': function ( data, type, row ) {
              if (type !== 'display') {
                return data;
              }
              // add a span to the Booking ID to indicate booking status
              return '<span class="booking-code-pill">'+ renderBookingLink(data) +'</span>';
          },
        },
        {
          'targets': [3, 4], 'className': 'text-center',
        },
        // {
        //   'targets': 8,
        //   'className': 'bg-gradient-success bg-success',
        // },
        // {
        //   'targets': 9,
        //   'className': 'bg-gradient-danger bg-danger',
        // }
      ],
    });

    if (searchString != null) {
      table.search( searchString ).draw();
    }

    // DataTables sum() plugin
    jQuery.fn.dataTable.Api.register( 'sum()', function ( ) {
        return this.flatten().reduce( function ( a, b ) {
            if ( typeof a === 'string' ) {
                a = a.replace(/[^\d.-]/g, '') * 1;
            }
            if ( typeof b === 'string' ) {
                b = b.replace(/[^\d.-]/g, '') * 1;
            }

            return a + b;
        }, 0 );
    });

    var tr_column_totals = [],
        active_revenue_year,
        getRevenueYearFromHash = function () {
          var matches = window.location.hash.match(/(\d+)/)
          return matches ? matches[0] : null
        },
        updateRevenueSummary = function (year) {
          var tab = $(`#revenue-table-year-tabs a[href="#tab-table-${year}"]`);

          if (!tab.length) {
            return;
          }

          $('[data-summary-field="total"]').text(tab.data('total'));
          $('[data-summary-field="best-month"]').text(tab.data('best-month'));
          $('[data-summary-field="best-month-total"]').text(tab.data('best-month-total'));
          $('[data-summary-field="average-month"]').text(tab.data('average-month'));
          $('[data-summary-field="active-spaces"]').text(tab.data('active-spaces'));
          $('[data-summary-field="yoy-delta"]').text(tab.data('yoy-delta'));
          $('[data-summary-field="yoy-percent"]').text(tab.data('yoy-percent'));
        };

    if (getRevenueYearFromHash()) {
      active_revenue_year = getRevenueYearFromHash()

      $('#revenue-table-year-tabs a').removeClass('active');
      $(`#revenue-table-year-tabs a[href="#tab-table-${active_revenue_year}"]`).addClass('active');
    } else {
      active_revenue_year = $('#revenue-table').data('active-year') || new Date().getFullYear()
    }

    updateRevenueSummary(active_revenue_year);

    var tableRevenues = $('#revenue-table').DataTable({
      pageLength : 100,
      ajax: `/json/revenue/${active_revenue_year}`,
      stateSave: true,
      'columnDefs': [{
          render: $.fn.dataTable.render.number( ',', '.', 2, '$' ),
          'targets': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
          'className': 'text-right',
        },
      ],
      columns: [
        {'data': 13, 'orderData': 0},
        {'data': 0},
        {'data': 1},
        {'data': 2},
        {'data': 3},
        {'data': 4},
        {'data': 5},
        {'data': 6},
        {'data': 7},
        {'data': 8},
        {'data': 9},
        {'data': 10},
        {'data': 11},
        {'data': 12},
      ],
      drawCallback: function () {
        var api = this.api();

        api.columns().every(function(column_number) {
          if (column_number != 0) {
            var column_sum = this.data().sum();
            $( api.column( column_number ).footer() ).html(`$${column_sum.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`);
          }
        });
      },
    });

    $('#revenue-table-year-tabs a').click(function (e) {
      window.location.hash = this.hash;
      active_revenue_year = getRevenueYearFromHash();
      if (!active_revenue_year) {
        return;
      }

      tableRevenues.ajax.url(`/json/revenue/${active_revenue_year}`).load();

      $('#revenue-table-year-tabs a').removeClass('active');
      $(`#revenue-table-year-tabs a[href="#tab-table-${active_revenue_year}"]`).addClass('active');
      updateRevenueSummary(active_revenue_year);
    });

    var tableCheckfront = $('#checkfront-table').DataTable({
      createdRow: function( row, data ) {
        if ( data[1] === 'missing' || data[1] === 'review' ) {
          $(row).addClass('table-danger');
        }

        if ( data[1] === 'sync' ) {
          $(row).addClass('table-warning');
        }

      },
      pageLength : 100,
      processing: true,
      serverSide: true,
      searchDelay: 250,
      scrollX: true,
      ajax: '/json/checkfront',
      stateSave: true,
      stateLoadParams: function( settings, data ) {
        if (data.columns && data.columns[1]) {
          data.columns[1].visible = false;
        }
      },
      order: [[ 5, 'desc' ], [ 10, 'desc' ]],
      columnDefs: [{
        targets: -1,
        data: null,
        orderable: false,
        className: 'text-center',
        defaultContent: '<button class="btn btn-sm btn-outline-secondary" title="Pull latest Checkfront details"><i class="fa fa-refresh" aria-hidden="true"></i></button>',
        },
        {
          targets: 0,
          className: 'text-nowrap',
          render: function ( data, type ) {
            if (type !== 'display') {
              return data;
            }

            return renderBookingLink(data);
          },
        },
        {
          targets: 1,
          visible: false,
          searchable: true,
        },
        {
          targets: [2, 3],
          className: 'text-center',
          render: function ( data, type ) {
            if (type !== 'display') {
              return data;
            }

            if (!data) {
              return '<span class="text-muted">none</span>';
            }

            if (data === 'PAID') {
              return '<span class="badge badge-success">PAID</span>';
            }

            if (data === 'HOLD' || data === 'RESERVED') {
              return '<span class="badge badge-primary">RESERVED</span>';
            }

            if (data === 'PEND' || data === 'PENDING') {
              return '<span class="badge badge-warning">PENDING</span>';
            }

            if (data === 'PART') {
              return '<span class="badge badge-deposit">DEPOSIT</span>';
            }

            if (data === 'STOP' || data === 'CANCELLED' || data === 'CANCELED' || data === 'VOID') {
              return '<span class="badge badge-danger">CANCELLED</span>';
            }

            return data;
          },
        },
        {
          targets: [7, 8, 9],
          render: $.fn.dataTable.render.number( ',', '.', 2, '$' ),
          className: 'text-nowrap text-right',
          createdCell: function( cell, cellData, rowData, rowIndex, colIndex ) {
            if (colIndex === 9 && cellData !== null && Math.abs(parseFloat(cellData)) > 0.01) {
              $(cell).addClass('font-weight-bold text-danger');
            }
          },
        },
        {
          targets: [5, 10, 11],
          className: 'text-nowrap',
          render: function ( data, type ) {
            if (type !== 'display' || !data) {
              return data;
            }

            return data.substring(0, 10);
          },
        },
        {
          targets: [6, 13],
          className: 'text-center text-nowrap',
        },
        {
          targets: [12],
          className: 'checkfront-issues-cell',
          render: function ( data, type ) {
            if (type !== 'display') {
              return data;
            }

            if (!data) {
              return '';
            }

            return data.split(', ').map(function(issue) {
              var icon = 'fa-exclamation-circle';
              var tone = 'danger';
              var escapedIssue = $('<div>').text(issue).html();

              if (issue === 'Missing local booking') {
                icon = 'fa-database';
              } else if (issue === 'Amount mismatch') {
                icon = 'fa-usd';
              } else if (issue === 'Status mismatch') {
                icon = 'fa-exchange';
                tone = 'warning';
              } else if (issue === 'Not refreshed') {
                icon = 'fa-refresh';
                tone = 'warning';
              }

              return '<span class="checkfront-issue-icon checkfront-issue-icon-'+ tone +'" title="'+ escapedIssue +'" aria-label="'+ escapedIssue +'"><i class="fa '+ icon +'" aria-hidden="true"></i></span>';
            }).join('');
          },
      }],
    });

    $('[data-checkfront-filter]').on('click', function() {
      var filter = $(this).data('checkfront-filter');

      $('[data-checkfront-filter]').removeClass('active');
      $(this).addClass('active');
      tableCheckfront.column(1).search(filter).draw();
    });

    $('#checkfront-sync-form').on('submit', function(e) {
      e.preventDefault();

      var form = $(this);
      var button = form.find('button[type="submit"]');
      var status = $('#checkfront-sync-status');

      button.prop('disabled', true).find('i').addClass('fa-spin');
      status.removeClass('d-none alert-success alert-danger').addClass('alert-info').text('Syncing Checkfront bookings...');

      $.getJSON(form.attr('action'), form.serialize(), function(data) {
        status.removeClass('alert-info alert-danger').addClass('alert-success').text(data.msg || 'Checkfront sync finished.');
        tableCheckfront.ajax.reload(null, false);
      }).fail(function() {
        status.removeClass('alert-info alert-success').addClass('alert-danger').text('Checkfront sync failed. Review the selected dates and try again.');
      }).always(function() {
        button.prop('disabled', false).find('i').removeClass('fa-spin');
      });
    });

    $('#checkfront-table tbody').on( 'click', 'button', function (e) {
      e.preventDefault();
      var booking = tableCheckfront.row( $(this).parents('tr') ).data();
      var row = $(this).parents('tr') ;
      var btn = $(this);

      btn.children().addClass('fa-spin');
      $.getJSON('/dashboard/pull/' + booking[0], function (data) {
        if(data.request.status=='OK') // make sure this really is success
        {
          btn.removeClass('btn-danger bg-gradient-danger');
          btn.addClass('btn-success bg-gradient-success');
          btn.children().removeClass('fa-spin');
          row.removeClass('table-danger');
          tableCheckfront.ajax.reload(null, false);

        } else {
          btn.addClass('btn-danger bg-gradient-danger');
          btn.children().removeClass('fa-spin');
        }
      }).fail(function() {
          btn.addClass('btn-danger bg-gradient-danger');
          btn.children().removeClass('fa-spin');
      });
    });


    $( '#noNights' ).change(function() {
      processPaymentFields();
    });
    $( '#payout' ).change(function() {
      processPaymentFields();
    });
    $( '#hostFee' ).change(function() {
      processPaymentFields();
    });
    $( '#cleaningFee' ).change(function() {
      processPaymentFields();
    });

    // Process the form fields if enough data exists
    if (parseFloat($('#payout').val()) && parseFloat($('#hostFee').val()) && parseFloat($('#cleaningFee').val())) {
      processPaymentFields();
    }

    function processPaymentFields() {
      var totalNet = (parseFloat($('#payout').val()) + parseFloat($('#hostFee').val()) - parseFloat($('#cleaningFee').val()) );
      $('#totalNet').val(totalNet);

      var num = (totalNet + parseFloat($('#cleaningFee').val()) );
      $('#totalGross').val(num);

      num = (totalNet / parseFloat($('#noNights').val())).toFixed(2);
      $('#nightlyRate').val(num);
    }

    // Will be filled with canvas
    var ChartJSPHP = new Array();

    // You must call this function after document.ready
    function loadChartJsPhp() {

      // Getting all chart.js canvas
      var elements = document.querySelectorAll('[data-chartjs]');

      // Looping every canvas
      elements.forEach(function(canvas) {
        var id = canvas.id;

        // Getting ctx from canvas
        var ctx = canvas.getContext('2d');

        // Getting values in data attributes
        var htmldata = canvas.dataset;
        var type = htmldata.chartjs;
        var data = JSON.parse(htmldata.data);
        var phpOptions = htmldata.options ? JSON.parse(htmldata.options) || {} : {};
        var options = $.extend(true, {}, phpOptions, {
            tooltips: {
              mode: 'label',
              callbacks: {
                label: function(tooltipItem, data) {
                  return data.datasets[tooltipItem.datasetIndex].label + ': ' + '$' + numberWithCommas(tooltipItem.yLabel.toFixed(2));
                },
              },
            },
            legend: {
                reverse: true,
              },
            elements: {
                line: {
                    tension: 0, // disables bezier curves
                },
            },
        });

        var config = {type:type, data:data, options:options};

        // Creating chart and saving for later use
        ChartJSPHP[id] = new Chart(ctx, config); // eslint-disable-line
      });
    }

    // Create the revenue chart
    $('#ChartJS').delay(1000).replaceWith(loadChartJsPhp());
    $('#annualGross').fadeIn(0); // the chart should pop on the page

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
